import * as React from 'react';
import {BlogGenericContentType} from '@nls-2022/nls-bll';
import {createBlogPostEntry, testCreateBlogPostEntry} from '@nls-2022/nls-api';
import {BlogPostsContext} from '../../containers/blog/BlogManagerContainer';
import {BlogPostsActionType, BlogPostsAction} from '@nls-2022/nls-bll';
import {Buffer} from 'buffer';
export type BlogPostContentDisplayType = {
  blogPostContent: BlogGenericContentType;
};
export const BlogPostContentDisplay = ({
  blogPostContent,
}: BlogPostContentDisplayType) => {
  const blogPostsContext = React.useContext(BlogPostsContext);
  const [postGenerated, setPostGenerated] = React.useState(false);
  const [postGeneratedError, setPostGeneratedError] = React.useState(false);

  React.useEffect(() => {
    const initForm = () => {
      setPostGenerated(false);
    };
    initForm();
  }, [blogPostContent]);

  let posts = blogPostsContext.state.blogPosts;
  let blogPostsDispatch = blogPostsContext.dispatchBlogPosts;
  const handlePostEntry = async () => {
    //let base64Content = Buffer.from(
    //  JSON.stringify(blogPostContent),
    //  'base64',
    //).toString();
    let base64Content = Buffer.from(JSON.stringify(blogPostContent)).toString(
      'base64',
    );
    let createPostResult = await createBlogPostEntry(base64Content);
    // let createPostResult = await testCreateBlogPostEntry(
    //   'f41d7f30-094c-4c5c-bc2a-2bae7bd03fe1',
    // );
    if (createPostResult.success) {
      blogPostsDispatch({
        type: BlogPostsActionType.BlogPostsAddPost,
        actionPayload: {
          blogPost: createPostResult.data,
          blogPostId: createPostResult.data.ID,
        },
      });
      setPostGenerated(true);
    } else {
      setPostGeneratedError(true);
    }
    //console.log(newEntry);
  };
  let categoryList: string = blogPostContent.categories.toString();
  let alreadyPosted =
    posts?.findIndex((u: {Title: string}) => {
      return (
        u.Title.toLowerCase().trim() ===
        blogPostContent.title.toLowerCase().trim()
      );
    })! >= 0;
  let disablePostButton = alreadyPosted || postGenerated;
  return (
    <>
      <h3>{`Blog Post Content ${alreadyPosted ? ' already posted' : ''}`}</h3>
      <p>{`${postGenerated ? 'created post' : ''}`}</p>
      <p>{`${postGeneratedError ? 'error occurred creating post' : ''}`}</p>
      <section className="pt-6 pb-8 mb-4 px-8">
        <p className="block text-gray-700 text-sm font-bold mb-2">Title</p>
        <p className="pb-2">{blogPostContent.title}</p>
        <p className="block text-gray-700 text-sm font-bold mb-2">Published</p>
        <p className="pb-2">
          {blogPostContent.isPublished ? 'published' : 'unpublished'}
        </p>
        <p className="block text-gray-700 text-sm font-bold mb-2">
          Published Date
        </p>
        <p className="pb-2">{blogPostContent.pubDate}</p>
        <p className="block text-gray-700 text-sm font-bold mb-2">Categories</p>
        <p className="pb-2">{categoryList}</p>
        <p className="block text-gray-700 text-sm font-bold mb-2">Excerpt</p>
        <p className="pb-2">{blogPostContent.excerpt}</p>
        <p className="block text-gray-700 text-sm font-bold mb-2">Content</p>
        <p>{blogPostContent.content}</p>
        <button
          disabled={disablePostButton}
          onClick={handlePostEntry}
          type="submit"
          className={`h-10 bg-green-500 border-green-500  text-sm border-4 text-white py-1 px-2 rounded uppercase ${
            !disablePostButton
              ? 'hover:bg-green-700 hover:border-green-700'
              : ''
          }`}
        >
          post to blog
        </button>
      </section>
    </>
  );
};
